import helpers from "../utils/utils";
import { FULLNAMECOOKIE } from "./Constant";
import store from "../../state/store";

export default () => {
  const { fullNamePublic, userId } = store.getState();
  const fullNamePublicCookie = helpers.getCookie(userId + FULLNAMECOOKIE);
  return fullNamePublic || fullNamePublicCookie;
};
